// extracted by mini-css-extract-plugin
module.exports = {"container":"e_MG","grayStyle":"e_NG"};